import { LOGO_PNG, scrollToId } from "@/data";

export default function Footer() {
    return (
        <footer
            className="border-t border-white/10 bg-[#121211] px-6 pb-10 pt-16 text-[#FAF8F5] lg:px-10"
            data-testid="site-footer"
        >
            <div className="mx-auto max-w-[1400px]">
                <div className="flex flex-col justify-between gap-10 lg:flex-row lg:items-end">
                    <div>
                        <img
                            src={LOGO_PNG}
                            alt="LILIKOOP Interactive Spaces"
                            className="h-14 w-auto"
                            data-testid="footer-logo"
                        />
                        <p className="mt-6 max-w-sm text-sm font-light leading-relaxed text-white/50">
                            Immersive 360° walkthroughs and cinematic aerial &
                            drone production. One team, one visual language — we
                            make physical spaces explorable.
                        </p>
                        <a data-testid="footer-email-link" href="mailto:hello@lilikoop.com" className="mt-6 inline-block font-mono2 text-[11px] uppercase tracking-[0.24em] text-white/50 transition-colors duration-300 hover:text-white">hello@lilikoop.com</a>
                    </div>
                    <nav className="flex flex-wrap gap-x-6 gap-y-3 sm:gap-8">
                        {[
                            { label: "Services", id: "services" },
                            { label: "Projects", id: "projects" },
                            { label: "About", id: "about" },
                            { label: "Contact", id: "contact" },
                        ].map((l) => (
                            <button
                                key={l.id}
                                data-testid={`footer-link-${l.id}`}
                                onClick={() => scrollToId(l.id)}
                                className="font-mono2 text-[10px] uppercase tracking-[0.26em] text-white/50 transition-colors duration-300 hover:text-white"
                            >
                                {l.label}
                            </button>
                        ))}
                    </nav>
                </div>
                <div className="mt-14 flex flex-col justify-between gap-3 border-t border-white/10 pt-6 font-mono2 text-[10px] uppercase tracking-[0.24em] text-white/35 sm:flex-row">
                    <p>© 2026 LILIKOOP Interactive Spaces</p>
                    <p>Los Angeles, California — 34.05° N · 118.25° W</p>
                </div>
            </div>
        </footer>
    );
}
